import React from "react";
import HeaderLogo from "./HeaderLogo";
import SearchBar from "./SearchBar";
import ModalScanner from "../scanner/ModalScanner";
import { useMediaQuery } from "react-responsive";
import "../../css/search.css";
import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";

export default function HeaderSearch({
  query,
  handleInputChange,
  scannerResult,
  onScanBarcode,
}) {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 640px)" });
  const { logout } = useAuth0();

  return (
    <header className="header">
      <div className="header-top">
        <HeaderLogo />
        <button
          type="button"
          className="back-button"
          aria-label="Se déconnecter"
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
        >
          <i className="fa fa-power-off" aria-hidden="true" />
        </button>
      </div>
      <SearchBar query={query} handleInputChange={handleInputChange} />
      {isTabletOrMobile && (
        <ModalScanner
          scannerResult={scannerResult}
          onScanBarcode={onScanBarcode}
        />
      )}
    </header>
  );
}

HeaderSearch.propTypes = {
  query: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  scannerResult: PropTypes.string,
  onScanBarcode: PropTypes.func.isRequired,
};
